import { Platform, Linking } from 'react-native';

import Communications from 'react-native-communications';

import validate from '../../../validate';

const WWW_URL_PATTERN = /^www\./i;

export const SCRAPE_PHONE_REGEX = validate.SCRAPE_PHONE_REGEX;

export function openUrl(url) {
  // When someone sends a message that includes a website address beginning with "www." (omitting the scheme),
  // react-native-parsed-text recognizes it as a valid url, but Linking fails to open due to the missing scheme.
  if (WWW_URL_PATTERN.test(url)) {
    url = `http://${url}`;
  }

  return Linking.canOpenURL(url)
    .then((supported) => {
      if (supported) {
        return Linking.openURL(url);
      } else {
        return Promise.reject('URL not supported');
      }
    })
    .catch((err) => {
      console.log('Linking error', url, err);
      return Promise.reject(err);
    });
}

export function openPhone(phoneNumber) {
  return openUrl(
    (Platform.OS === 'ios' ? 'telprompt' : 'tel') + ':' + phoneNumber.replace(/[^\d]/g, '')
  );
}

export function openPhoneOptions(phoneNumber, actionSheet) {
  if (!actionSheet) return openPhone(phoneNumber);

  const options = ['Call', 'Text', 'Cancel'];
  const cancelButtonIndex = options.length - 1;
  actionSheet.showActionSheetWithOptions(
    {
      options,
      cancelButtonIndex,
    },
    (buttonIndex) => {
      switch (buttonIndex) {
        case 0:
          Communications.phonecall(phoneNumber, true);
          break;
        case 1:
          Communications.text(phoneNumber);
          break;
        default:
          break;
      }
    }
  );
}

export function openEmail(email) {
  Communications.email([email], null, null, null, null);
}
